import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import SupervisiCssdSvc, {
  SupervisiCssdListFilter,
} from "@/services/SupervisiCssdService";
import { SupervisiCssd } from "@/types/SupervisiCssd";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "supervisi-cssd",
})
class SupervisiCssdModule extends VuexModule {
  items: SupervisiCssd[] = [];
  currentItem: SupervisiCssd | null = null;
  loading = false;
  meta: {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
  } | null = null;

  @Mutation SET_ITEMS(val: SupervisiCssd[]) {
    this.items = val || [];
  }

  @Mutation SET_CURRENT_ITEM(val: SupervisiCssd | null) {
    this.currentItem = val;
  }

  @Mutation SET_META(val: any) {
    this.meta = val || null;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async fetchList(params: SupervisiCssdListFilter = {}) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiCssdSvc.list(params);
      this.SET_ITEMS(dt.data.data || []);
      this.SET_META(dt.data.meta || null);
    } catch {
      this.SET_ITEMS([]);
      this.SET_META(null);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await SupervisiCssdSvc.find(id);
      this.SET_CURRENT_ITEM(dt.data.data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
    this.SET_META(null);
  }
}

export const storeSupervisiCssd = getModule(SupervisiCssdModule);
